const HEADER_SELECTOR = '.header';
const FIXED_CLASS = 'fixed';

const header = document.querySelector(HEADER_SELECTOR);

if (header) {
    const updateHeaderState = () => {
        header.classList.toggle(FIXED_CLASS, window.scrollY > 0);
    };

    // Set the initial state and keep it in sync while scrolling.
    updateHeaderState();
    window.addEventListener('scroll', updateHeaderState, { passive: true });
}

